import React, { useEffect, useState, useRef, useMemo, Fragment } from "react";
import { useCursorPopup, useRedux } from "hooks";
import { createSelector } from "reselect";
import { UserStruct } from "api";
import { Utils } from "helpers/utils";
import { TaskStatus, WpEmpFilterType, WpSliceData } from "../../../redux/workplace/wpTypes";
import UserAvatarWithName from "components/UserAvatarWithName";
import classnames from "classnames";
import AppSimpleBar from "components/AppSimpleBar";
import { loadPostTitleActionV2, loadTaskDashActV2, loadTaskDashboardByDivAct, loadTaskDashRecurance, loadTaskDashStatusRangeActV2, loadTaskDashTagsActV2, setTaskDashFilterTagId } from "../../../redux/workplace/wpActions";
import { WpModes } from "../../../constants";
import HelpInfo from "components/HelpInfo";
import DatePickerEx from "components/DatePickerEx";
import { ElementWidthObserver } from "components/ElementWidthObserver";
import Loader from "components/Loader";
import LoadingIconWithText from "components/LoadingIconWithText";
import { DashTaskTabs, StorageUtils } from "helpers/storageutils";
import Select, { components, OptionProps, SingleValueProps, DropdownIndicatorProps, IndicatorSeparatorProps, useStateManager } from 'react-select';
import SelectDropdown from "components/SelectDropdown";
import { Const, RecuranceModes } from "const";
import UserAvatar from "components/UserAvatar";
import { useDialog } from "DialogProvider";

const SMALL_SCREEN = 1000;
const UPCOMING_DAY = 7;

const LineDash: React.FC = ({ }) => {
  return (
    <div className="mt-2 mb-2" style={{ borderTop: "dashed 1px var(--m2-line-divider-color)" }}></div>
  );

}

type CurrentFilterType = null | "COMING_DUE" | "OVERDUE" | "DUE_TODAY";

const taskStatuses = [TaskStatus.ToDo, TaskStatus.OnGoing, TaskStatus.Hold, TaskStatus.Cancel, TaskStatus.Finished];

let lastTaskCount = 0;
const fnGetTaskCount = (taskSummary: any, filterTagId: number | null) => {
  if (filterTagId == null) {
    const total = (taskSummary?.status_ToDo ?? 0) + (taskSummary?.status_Finished ?? 0) + (taskSummary?.status_Cancel ?? 0) + (taskSummary?.status_OnGoing ?? 0) + (taskSummary?.status_Hold ?? 0);
    lastTaskCount = total;
  }
  return lastTaskCount;
}


interface StatusSummaryProps {
  title: "MINE" | "ALL";
  data: any;
  onReloadTaskTitle(fromDivGroup: boolean, taskStatus: TaskStatus | null, respondId: string | null | undefined, respondTagId: number[] | null, assignerId: any, requesterId: any, keyword: string): void;
  curUserId: number;
  curUserTagId: number;
  filterTagId: number | null;
}

const StatusSummary: React.FC<StatusSummaryProps> = ({ title, data, onReloadTaskTitle, curUserId, curUserTagId, filterTagId }) => {
  const total = fnGetTaskCount(data, filterTagId);
  if (total <= 0 && title === "MINE") return (<></>);
  return (
    <div className="tkd-status-summary-card wp-conver-content" style={{ height: "100%" }}>
      <h4 className="">{title === "MINE" ? "งานของฉัน" : "งานทั้งหมด"}</h4>
      <LineDash />
      <div className="tkd-status-grid">
        {taskStatuses.map((item: TaskStatus, index) => {
          const statusName = TaskStatus[item];
          const propName = "status_" + statusName.replaceAll(" ", "");
          const icon = Utils.GetTaskStatusIcon(item);
          const css = "badge-task-status-" + statusName.toLowerCase();
          const responder = (title == "MINE" ? curUserId : null) ?? null;
          const responderTagId = (title == "MINE" ? [] : null) ?? null;
          const statusText = Utils.GetTaskStatusText(item);

          return (
            <div
              key={index} className={"d-flex justify-content-between hover hand " + css}
              onClick={(e) => onReloadTaskTitle(false, item, responder?.toString(), responderTagId, null, null, "")}
            >
              <div>{icon}{statusText} </div>
              <div>{data ? data[propName] : 0}</div>
            </div>
          )
        })}
        {/* <div className="d-flex justify-content-between"><div>To Do </div><div>{data["status_ToDo"]}</div></div>
          <div className="d-flex justify-content-between"><div>On Going </div><div>{data.status_OnGoing}</div></div>
          <div className="d-flex justify-content-between"><div>Finished </div><div>{data.status_Finished}</div></div>
          <div className="d-flex justify-content-between"><div>Hold </div><div>{data.status_Hold}</div></div>
          <div className="d-flex justify-content-between"><div>Cancel </div><div>{data.status_Cancel}</div></div> */}
      </div>
    </div>
  );
};
interface RangeStatusStatProps {
  onDateChange(date1: Date | null, date2: Date | null): void;
  taskStatusRange: any;
  taskDashStatusLoading: boolean;
  onFilterTaskTitle(mode: "NEW_TASK" | "FINISHED_TASK" | "COMING_DUE" | "DUE_TODAY" | "OVERDUE"): void;
}
const RangeStatusStat: React.FC<RangeStatusStatProps> = ({ onDateChange, taskStatusRange, taskDashStatusLoading, onFilterTaskTitle }) => {
  const [showCustomDate, setShowCustomDate] = useState<boolean>(false);

  const [date1, setDate1] = useState<Date | null>(null);
  const [date2, setDate2] = useState<Date | null>(null);

  const today = new Date();
  const prevWeek = new Date(new Date(today).setDate(today.getDate() - 7));
  const prevMonth = new Date(new Date(today).setMonth(today.getMonth() - 1));

  const dates = {
    thisWeek1: Utils.GetFirstDateOfWeek(today),
    thisWeek2: Utils.GetLastDateOfWeek(today),
    prevWeek1: Utils.GetFirstDateOfWeek(prevWeek),
    prevWeek2: Utils.GetLastDateOfWeek(prevWeek),
    thisMonth1: Utils.GetFirstDateOfMonth(today),
    thisMonth2: Utils.GetLastDateOfMonth(today),
    prevMonth1: Utils.GetFirstDateOfMonth(prevMonth),
    prevMonth2: Utils.GetLastDateOfMonth(prevMonth),
  }

  const isSameDay = (a: Date | null, b: Date) => a?.getFullYear() === b.getFullYear() && a?.getMonth() === b.getMonth() && a?.getDate() === b.getDate();

  const isThisWeek = (date1 == null && date2 == null) || isSameDay(date1, dates.thisWeek1) && isSameDay(date2, dates.thisWeek2);
  const isPrevWeek = isSameDay(date1, dates.prevWeek1) && isSameDay(date2, dates.prevWeek2);
  const isThisMonth = isSameDay(date1, dates.thisMonth1) && isSameDay(date2, dates.thisMonth2);
  const isPrevMonth = isSameDay(date1, dates.prevMonth1) && isSameDay(date2, dates.prevMonth2);
  const isOtherRange = !(isThisWeek || isPrevWeek || isThisMonth || isPrevMonth);

  const onClickHeader = (e: React.MouseEvent) => {
    openAtCursor(e);
    setShowCustomDate(prev => !prev);
  }
  useEffect(() => {
    if (showCustomDate) {
      if (date1 == null || date2 == null) {
        setDate1(Utils.GetFirstDateOfWeek(today));
        setDate2(Utils.GetLastDateOfWeek(today));
      }
    }
  }, [showCustomDate]);
  const setDateRange = (range: "THIS_WEEK" | "PREV_WEEK" | "THIS_MONTH" | "PREV_MONTH") => {
    let dt1 = new Date();
    let dt2 = new Date();
    switch (range) {
      case "THIS_WEEK": dt1 = dates.thisWeek1; dt2 = dates.thisWeek2; break;
      case "PREV_WEEK": dt1 = dates.prevWeek1; dt2 = dates.prevWeek2; break;
      case "THIS_MONTH": dt1 = dates.thisMonth1; dt2 = dates.thisMonth2; break;
      case "PREV_MONTH": dt1 = dates.prevMonth1; dt2 = dates.prevMonth2; break;
    }
    setDate1(dt1);
    setDate2(dt2);
    onOk(dt1, dt2);
  }

  const { ref: popRef, pos: popCur, openAtCursor } = useCursorPopup(
    showCustomDate,
    () => setShowCustomDate(false)
  );

  const onOk = (dt1: Date | null, dt2: Date | null) => {
    setShowCustomDate(false);
    onDateChange(dt1 ?? date1, dt2 ?? date2);

  }


  const caption = isThisWeek ? "อาทิตย์นี้" : isPrevWeek ? "อาทิตย์ก่อน" : isThisMonth ? "เดือนนี้" : isPrevMonth ? "เดือนก่อน" : (date1 == null || date2 == null ? "อาทิตย์นี้" : (Utils.getDateRangeText(date1, date2)));

  return (
    <>
      <div className="tkd-status-summary-card wp-conver-content" style={{ position: "relative" }}>
        {taskDashStatusLoading && (<Loader />)}
        {/* <h4 className="hand no-wrap overflow-hide" onClick={onClickHeader}><u>{caption}</u></h4> */}
        <div className="no-wrap">
          <span className={"wp-tag-filter hand mb-2 hover badge-task-status-todo " + (isThisWeek ? "active-primary" : "")} title="อาทิตย์นี้" onClick={() => setDateRange("THIS_WEEK")}>TW</span>
          <span className={"wp-tag-filter hand mb-2 hover badge-task-status-todo " + (isPrevWeek ? "active-primary" : "")} title="อาทิตย์ก่อน" onClick={() => setDateRange("PREV_WEEK")}>LW</span>
          <span className={"wp-tag-filter hand mb-2 hover badge-task-status-todo " + (isThisMonth ? "active-primary" : "")} title="เดือนนี้" onClick={() => setDateRange("THIS_MONTH")}>TM</span>
          <span className={"wp-tag-filter hand mb-2 hover badge-task-status-todo " + (isPrevMonth ? "active-primary" : "")} title="เดือนก่อน" onClick={() => setDateRange("PREV_MONTH")}>LM</span>
          <span className={"wp-tag-filter hand mb-2 hover badge-task-status-todo " + (isOtherRange ? "active-primary" : "")} title="อื่น ๆ" onClick={onClickHeader}>Other</span>
        </div>

        <LineDash />
        <div className="tkd-status-grid" >
          <div className={"d-flex justify-content-between hand hover badge-task-status-todo"} onClick={(e) => onFilterTaskTitle("NEW_TASK")}><span>📋งานเปิดใหม่</span><span>{taskStatusRange?.inRangeOpen}</span></div>
          <div className={"d-flex justify-content-between hand hover badge-task-status-finished"} onClick={(e) => onFilterTaskTitle("FINISHED_TASK")}><span>✅งานเสร็จ</span><span>{taskStatusRange?.inRangeFinished}</span></div>
        </div>
      </div>
      <div style={{ height: "10px" }}></div>
      <div className="tkd-status-summary-card wp-conver-content" style={{ position: "relative" }} >
        <div className={"d-flex justify-content-between hand hover badge-task-status-todo"} title="งานใกล้กำหนดในอีก 7 วัน" onClick={(e) => onFilterTaskTitle("COMING_DUE")}><span><span style={{ display: "inline-block", width: "1.5em" }}>⏳</span>ใกล้กำหนด</span><span>{taskStatusRange?.cominigDue}</span></div>
        <div className={"d-flex justify-content-between hand hover badge-task-status-ongoing"} title="ครบกำหนดวันนี้" onClick={(e) => onFilterTaskTitle("DUE_TODAY")}><span><span style={{ display: "inline-block", width: "1.5em" }}>⚡️</span>ครบกำหนดวันนี้</span><span>{taskStatusRange?.dueToday}</span></div>
        <div className={"d-flex justify-content-between hand hover badge-task-status-cancel"} title="งานเลยกำหนด" onClick={(e) => onFilterTaskTitle("OVERDUE")}><span><span style={{ display: "inline-block", width: "1.5em" }}>🚨</span>เลยกำหนด</span><span>{taskStatusRange?.overdue}</span></div>
      </div>

      {showCustomDate && (
        <div ref={popRef} className="wp-conver-content" style={{ zIndex: "9", width: "230px", position: "fixed", top: popCur.y + 20, left: popCur.x - 50 }}>
          <div>
            <span onClick={(e) => setDateRange("THIS_WEEK")} className={classnames("wp-tag-filter hand hover fz-12", { "active-primary": isThisWeek })}>อาทิตย์นี้</span>
            <span onClick={(e) => setDateRange("PREV_WEEK")} className={classnames("wp-tag-filter hand hover fz-12", { "active-primary": isPrevWeek })}>อาทิตย์ก่อน</span>
            <span onClick={(e) => setDateRange("THIS_MONTH")} className={classnames("wp-tag-filter hand hover fz-12", { "active-primary": isThisMonth })}>เดือนนี้</span>
            <span onClick={(e) => setDateRange("PREV_MONTH")} className={classnames("wp-tag-filter hand hover fz-12", { "active-primary": isPrevMonth })}>เดือนก่อน</span>
          </div>
          <div>
            หรือ จาก
            <DatePickerEx isDisabled={false} onDateChanged={(e) => setDate1(e)} selectedDate={date1} />
            ถึง
            <DatePickerEx isDisabled={false} onDateChanged={(e) => setDate2(e)} selectedDate={date2} />
          </div>
          <div className="d-flex justify-content-end mt-2" style={{ gap: "6px" }}>
            <button className="btn btn-secondary" onClick={(e) => setShowCustomDate(false)}>ปิด</button>
            <button className="btn btn-primary" onClick={(e) => onOk(null, null)}>ตกลง</button>
          </div>
        </div>
      )}

    </>
  );
};

interface UserHeaderProps {
  user: UserStruct;
  myTaskSummary: any;
  allTaskSummary: any;
  onReloadTaskTitle(fromDivGroup: boolean, taskStatus: TaskStatus | null, respondId: string | null | undefined, respondTagId: number[] | null, assignerId: any, requesterId: any, keyword: string): void;
  curUserId: number;
  curUserTagId: number;
  onDateChange(date1: Date | null, date2: Date | null): void;
  taskStatusRange: any;
  taskDashLoading: boolean;
  taskDashStatusLoading: boolean;
  onFilterTaskTitle(mode: "NEW_TASK" | "FINISHED_TASK" | "COMING_DUE" | "DUE_TODAY" | "OVERDUE"): void;
  onRefresh(): void;
  onFilterTagChange(tagID: number | null): void;
  filterTagId: number | null;
  includeTaskRecurance: boolean;
  setIncludeTaskRecurance(val: boolean): void;
}

const UserHeader: React.FC<UserHeaderProps> = ({ includeTaskRecurance, setIncludeTaskRecurance, user, myTaskSummary, allTaskSummary, onReloadTaskTitle, curUserId, curUserTagId, onDateChange, onRefresh, onFilterTagChange, taskStatusRange, taskDashLoading, taskDashStatusLoading, onFilterTaskTitle, filterTagId }) => {

  return (
    // <div className="tkd-user-header">
    //   {/* <div className="tkd-user-info">
    //     <UserAvatar profileImage={user.pictureUrl ?? "/avatar-default.png"} size="lg" />
    //   </div>

    //   <div className="tkd-summary-area">
    //     <StatusSummary title="MINE" data={myTaskSummary} />
    //     <StatusSummary title="ALL" data={allTaskSummary} />
    //   </div> */}
    //   <StatusSummary title="MINE" data={myTaskSummary} />
    //   <StatusSummary title="ALL" data={allTaskSummary} />
    // </div>
    <>
      <TagListControl onFilterTagChange={onFilterTagChange} filterTagId={filterTagId} includeTaskRecurance={includeTaskRecurance} setIncludeTaskRecurance={setIncludeTaskRecurance} />
      <div className="row">
        <div className={classnames("col ", { "hide": fnGetTaskCount(myTaskSummary, filterTagId) <= 0 })}>
          <StatusSummary title="MINE" data={myTaskSummary} onReloadTaskTitle={onReloadTaskTitle} curUserId={curUserId} curUserTagId={curUserTagId} filterTagId={filterTagId} />
        </div>
        <div className={classnames("col ")}>
          <StatusSummary title="ALL" data={allTaskSummary} onReloadTaskTitle={onReloadTaskTitle} curUserId={curUserId} curUserTagId={curUserTagId} filterTagId={filterTagId} />
        </div>
        <div className="col ">
          <RangeStatusStat onDateChange={onDateChange} taskStatusRange={taskStatusRange} taskDashStatusLoading={taskDashStatusLoading} onFilterTaskTitle={onFilterTaskTitle} />
        </div>
      </div>
    </>
  );
};




const TAB_ALL = "a";
const TAB_ASS = "b";
const TAB_REQ = "c";
const TAB_DIV = "d";

interface TaskTableProps {
  data: any[];
  activeTab: string;
  onReloadTaskTitle(fromDivGroup: boolean, taskStatus: TaskStatus | null, respondId: string | null | undefined, respondTagId: number[] | null, assignerId: any, requesterId: any, keyword: string): void;
  curUserId: number;
  curUserTagId: number;
  containerWidth: number;
  filterType: CurrentFilterType;
  filterTagId: number | null;
  includeTaskRecurance: boolean;
}

const TaskTable: React.FC<TaskTableProps> = ({ data, activeTab, onReloadTaskTitle, curUserId, curUserTagId, containerWidth, filterType, filterTagId, includeTaskRecurance }) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.WpSlice,
    (wp: WpSliceData) => ({
      taskDashByDivRsp: wp.taskDashByDivRsp,
      taskDashByDivAsg: wp.taskDashByDivAsg,
      taskDashByDivReq: wp.taskDashByDivReq,
      taskDashByDivLoading: wp.taskDashByDivLoading,
    })
  );
  const { taskDashByDivRsp, taskDashByDivAsg, taskDashByDivReq, taskDashByDivLoading } = useAppSelector(storeData);
  // console.log('taskDashByDivRsp:', taskDashByDivRsp);

  const [taskDashDivMode, setTaskDashDivMode] = useState<"DIV_RSP" | "DIV_ASG" | "DIV_REQ">(StorageUtils.TaskDashDivMode);
  useEffect(() => {
    StorageUtils.TaskDashDivMode = taskDashDivMode;
  }, [taskDashDivMode]);

  const dataForDivision = taskDashDivMode == "DIV_RSP" ? taskDashByDivRsp : taskDashDivMode == "DIV_ASG" ? taskDashByDivAsg : taskDashDivMode == "DIV_REQ" ? taskDashByDivReq : null;
  // console.log('dataForDivision:', dataForDivision);

  const isSmallScreen = containerWidth <= SMALL_SCREEN;
  const groupByDivision = activeTab === TAB_DIV;
  const statufPrefix = filterType == null ? "" : filterType == "COMING_DUE" ? "Coming" : filterType == "DUE_TODAY" ? "DueToday" : filterType == "OVERDUE" ? "Delay" : "";
  const filterKeyword = filterType == null ? "" : filterType == "COMING_DUE" ? "COMING_DUE" : filterType == "DUE_TODAY" ? "DUE_TODAY" : filterType == "OVERDUE" ? "OVERDUE" : "";
  // console.log('data:', data);
  const divisions = (groupByDivision && dataForDivision)
    ? Object.values(
      dataForDivision.reduce((acc, item) => {
        const key = item.divisionName;

        if (!acc[key]) {
          acc[key] = {
            divisionName: key,
            status_ToDo: 0,
            status_Finished: 0,
            status_Cancel: 0,
            status_OnGoing: 0,
            status_Hold: 0,
            respondTagIds: "",
          };
        }

        acc[key].status_ToDo += item['status' + statufPrefix + '_ToDo'] ?? 0;
        acc[key].status_Finished += item['status' + statufPrefix + '_Finished'] ?? 0;
        acc[key].status_Cancel += item['status' + statufPrefix + '_Cancel'] ?? 0;
        acc[key].status_OnGoing += item['status' + statufPrefix + '_OnGoing'] ?? 0;
        acc[key].status_Hold += item['status' + statufPrefix + '_Hold'] ?? 0;
        if (item.respondTagIds) {
          const prev = acc[key].respondTagIds;
          acc[key].respondTagIds = prev + (prev ? "|" : "") + item.respondTagIds;
        }
        // acc[key].respondTagIds.push(item.respondTagIds);

        return acc;
      }, {} as Record<string, any>)
    ).sort((a: any, b: any) => a.divisionName.localeCompare(b.divisionName))
    : [{}];
  // if (groupByDivision) {
  //   console.log('divisions:', { dataForDivision, divisions });
  // }

  const groupByStatus = ((groupByDivision ? dataForDivision : data) ?? []).reduce((acc, item) => {
    acc[TaskStatus.ToDo] = (acc[TaskStatus.ToDo] ?? 0) + (item['status' + statufPrefix + '_ToDo'] ?? 0);
    acc[TaskStatus.Finished] = (acc[TaskStatus.Finished] ?? 0) + (item['status' + statufPrefix + '_Finished'] ?? 0);
    acc[TaskStatus.Cancel] = (acc[TaskStatus.Cancel] ?? 0) + (item['status' + statufPrefix + '_Cancel'] ?? 0);
    acc[TaskStatus.OnGoing] = (acc[TaskStatus.OnGoing] ?? 0) + (item['status' + statufPrefix + '_OnGoing'] ?? 0);
    acc[TaskStatus.Hold] = (acc[TaskStatus.Hold] ?? 0) + (item['status' + statufPrefix + '_Hold'] ?? 0);
    return acc;
  }, {} as Record<string, any>);

  // console.log('groupByStatus:' + groupByDivision + ' tab = ' + activeTab, { groupByStatus, dataForDivision });


  const [memDivCollapse, setMemDivCollapse] = useState<string[]>((localStorage.getItem("dshdiv") ?? "").split('|'));
  useEffect(() => { localStorage.setItem("dshdiv", memDivCollapse.join("|")); }, [memDivCollapse])
  const toggleDiv = (divName: string) => {
    // setMemDivCollapse(prev => {
    //   if (prev.includes(divName)) {
    //     return prev.filter(x => x !== divName);
    //   } else {
    //     return [divName, ...prev];
    //   }
    // });
    // bellow is one div open in a time
    setMemDivCollapse(prev => {
      if (prev.includes(divName)) {
        return [];
      } else {
        return [divName];
      }
    });
  };

  const [nameFilter, setNameFilter] = useState<string>("");
  const matchesNameFilter = (row: any): boolean => {
    if (!nameFilter.trim()) return true;
    const tokens = nameFilter.toLowerCase().split(/\s+/).filter(t => t.length > 0);
    const haystack = [row.displayName, row.displayName2, row.abbrName].filter(Boolean).join(" ").toLowerCase();
    return tokens.some(token => haystack.includes(token));
  };

  const onGroupByDivChange = (value: string) => {
    const divMode = value as "DIV_RSP" | "DIV_ASG" | "DIV_REQ";
    setTaskDashDivMode(divMode);
    dispatch(loadTaskDashboardByDivAct(divMode, null, null, filterTagId, includeTaskRecurance));
  }

  const onLoadTaskTitleByStatus = (status: TaskStatus) => {
    // console.log('status = ' + status + ', tab = ' + activeTab + ' mode = ' + StorageUtils.TaskDashDivMode);
    if (activeTab == TAB_DIV) {
      const divMode = StorageUtils.TaskDashDivMode;
      const divNames = Array.from(new Set((dataForDivision ?? []).map(x => x.divisionName))).join('|');
      const respondTagIds = Array.from(new Set((dataForDivision ?? []).map(x => x.respondTagIds))).join('|') as any;
      onReloadTaskTitle(true, status, divNames, respondTagIds.split('|'), divMode == "DIV_ASG" ? divNames : null, divMode == "DIV_REQ" ? divNames : null, "");
    } else {
      const respondIds = Array.from(new Set((data ?? []).map(x => x.respondId))).join('|');
      const respondTagIds = Array.from(new Set((data ?? []).map(x => x.respondTagIds))).join('|') as any;
      onReloadTaskTitle(false, status, "000|" + respondIds, respondTagIds.split('|'), activeTab == TAB_ASS ? curUserId : null, activeTab == TAB_REQ ? curUserId : null, ""); /* 000| = trick  for check if value is number in procedure */
    }
  }

  return (
    <>
    <AppSimpleBar className="wp-content-base" style={{ maxHeight: "calc(100vh - 430px)", width: "100% !important", maxWidth: "100% !important" }}>
      {(groupByDivision && taskDashByDivLoading) && (<Loader />)}
      <table className="tkd-task-table w-100" style={{ width: "100%" }}>
        <thead>
          <tr>
            <th align="left">
              {groupByDivision && (
                <div className="d-flex align-items-center" style={{ gap: "4px" }}>
                  <select className="form-control" style={{ backgroundColor: "var(--th-bg)", appearance: "auto", width: "auto" }} value={taskDashDivMode} onChange={(e) => onGroupByDivChange(e.target.value)}>
                    <option value={"DIV_RSP"}>เจ้าของงาน</option>
                    <option value={"DIV_ASG"}>ผู้มอบหมาย</option>
                    <option value={"DIV_REQ"}>ผู้ขอ</option>
                  </select>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="ค้นหาชื่อ..."
                    value={nameFilter}
                    onChange={e => setNameFilter(e.target.value)}
                    style={{ minWidth: "84px" }}
                  />
                </div>
              )}
              {!groupByDivision && (
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="เจ้าของงาน..."
                  value={nameFilter}
                  onChange={e => setNameFilter(e.target.value)}
                  style={{ minWidth: "120px" }}
                />
              )}
            </th>
            {taskStatuses.map((x: TaskStatus) => (
              <th key={'h' + x} align="center" className="hover hand" onClick={(e) => onLoadTaskTitleByStatus(x)}>
                {Utils.GetTaskStatusIcon(x)}{isSmallScreen ? "" : Utils.GetTaskStatusText(x)}
                <br />
                {groupByStatus[x]}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {divisions.map((div: any, idxDiv: number) => {
            const emp = groupByDivision ? (dataForDivision ?? []).filter(x => x.divisionName == div.divisionName) : (data ?? []);
            const filteredEmp = nameFilter.trim() ? emp.filter(matchesNameFilter) : emp;
            if (groupByDivision && nameFilter.trim() && filteredEmp.length === 0) return null;
            const divCollapse = groupByDivision ? memDivCollapse.includes(div.divisionName) : true;
            const divKey = groupByDivision ? div.divisionName : "";
            return (
              <Fragment key={idxDiv}>
                {div.divisionName && (
                  <tr key={divKey + idxDiv} className="text-primary">
                    <td className="hand hover " onClick={(e) => toggleDiv(div.divisionName)}><i className={"fas fa-angle-double-" + (divCollapse ? "up" : "down") + " me-1"}></i>{div.divisionName}</td>
                    {taskStatuses.map((x: TaskStatus) => {
                      const field = "status_" + TaskStatus[x];
                      const count = div[field] ?? 0;
                      return (
                        <td
                          key={divKey + x}
                          align="center" className={classnames({ "hand hover ": count > 0 })}
                          onClick={(e) => count > 0 ? onReloadTaskTitle(groupByDivision, x, div.divisionName, div.respondTagIds.split('|'),
                            StorageUtils.TaskDashDivMode == "DIV_ASG" ? div.divisionName : null,
                            StorageUtils.TaskDashDivMode == "DIV_REQ" ? div.divisionName : null, filterKeyword) : null}
                        >
                          {count > 0 ? count : ""}
                        </td>
                      )
                    })}
                  </tr>
                )}
                {divCollapse && filteredEmp.map((row, idx) => {
                  let assignerId = (activeTab == TAB_ASS ? curUserId : null) ?? null;
                  let requesterId = (activeTab == TAB_REQ ? curUserId : null) ?? null;
                  if (groupByDivision) {
                    assignerId = StorageUtils.TaskDashDivMode == "DIV_ASG" ? row.userId : null;
                    requesterId = StorageUtils.TaskDashDivMode == "DIV_REQ" ? row.userId : null;
                  }
                  return (
                    <tr key={divKey + idx}>
                      <td className={"hand hover " + (groupByDivision ? " ps-3" : "")}
                        onClick={(e) => onReloadTaskTitle(groupByDivision, null, row.respondId, groupByDivision ? row.respondTagIds.split('|') : [row.respondTagId], assignerId, requesterId, filterKeyword)}
                      >
                        {row.displayName}
                        <UserAvatarWithName keyValue={idx} abbrName={row.abbrName} backColor={row.bgColor} displayName2={row.displayName2} foreColor={row.foreColor} profileImage={row.profileImage} userId={row.respondId} />
                      </td>
                      {taskStatuses.map((x: TaskStatus) => {
                        const field = "status" + statufPrefix + '_' + TaskStatus[x];
                        const count = row[field] ?? 0;
                        return (
                          <td
                            key={divKey + idx + '.' + x}
                            align="center" className={classnames({ "hand hover ": count > 0 })}
                            onClick={(e) => count > 0 ? onReloadTaskTitle(groupByDivision, x, row.respondId, groupByDivision ? row.respondTagIds.split('|') : [row.respondTagId], assignerId, requesterId, filterKeyword) : null}
                          >
                            {count > 0 ? count : ""}
                          </td>
                        )
                      })}
                    </tr>
                  )
                })}
              </Fragment>
            )
          })}
        </tbody>
      </table>
    </AppSimpleBar>
    </>
  );
};




interface TaskTabsProps {
  allTasks: any[];
  assignerTasks: any[];
  requesterTasks: any[];
  curUserId: number;
  curUserTagId: number;
  containerWidth: number;
  onReloadTaskTitle(fromDivGroup: boolean, taskStatus: TaskStatus | null, respondId: string | null | undefined, respondTagId: number[] | null, assignerId: any, requesterId: any, keyword: string): void;
  filterType: CurrentFilterType;
  onClearFilterType(): void;
  filterTagId: number | null;
  includeTaskRecurance: boolean;
}

const TaskTabs: React.FC<TaskTabsProps> = ({ allTasks, assignerTasks, requesterTasks, onReloadTaskTitle, curUserId, curUserTagId, containerWidth, filterType, onClearFilterType, filterTagId, includeTaskRecurance }) => {
  const [activeTab, setActiveTab] = useState<string>(localStorage.getItem("tkdtab") ?? TAB_ALL);

  const getData = () => {
    switch (activeTab) {
      case TAB_ASS:
        return assignerTasks;
      case TAB_REQ:
        return requesterTasks;
      case TAB_DIV:
        return allTasks;
      default:
        return allTasks;
    }
  };
  useEffect(() => {
    localStorage.setItem("tkdtab", activeTab);
  }, [activeTab]);

  const a1 = activeTab == TAB_ALL ? "" : "outline-";
  const a2 = activeTab == TAB_ASS ? "" : "outline-";
  const a3 = activeTab == TAB_REQ ? "" : "outline-";
  const a4 = activeTab == TAB_DIV ? "" : "outline-";

  return (
    <div className="tkd-task-tabs">
      <div className="tkd-tab-header mb-1" >
        <div className="d-flex justify-content-between">
          <div>
            <button className={classnames("btn2 btn-sm fz-10 btn2-" + a1 + "secondary hand hover")} onClick={() => setActiveTab(TAB_ALL)}>งานทั้งหมด</button>
            <button className={classnames("btn2 btn-sm fz-10 btn2-" + a2 + "secondary hand hover")} onClick={() => setActiveTab(TAB_ASS)}>งานที่มอบหมาย</button>
            <button className={classnames("btn2 btn-sm fz-10 btn2-" + a3 + "secondary hand hover")} onClick={() => setActiveTab(TAB_REQ)}>งานที่ขอ</button>
            <button className={classnames("btn2 btn-sm fz-10 btn2-" + a4 + "secondary hand hover")} onClick={() => setActiveTab(TAB_DIV)}>ตามหน่วยงาน</button>
          </div>
          {filterType != null && (
            <button className={"btn2 btn2-" + (filterType == "OVERDUE" ? "danger" : "warning")} onClick={onClearFilterType}><i className="fa fa-filter me-1"></i>
              {filterType == "COMING_DUE" ? "ใกล้กำหนด" : filterType == "DUE_TODAY" ? "ครบกำหนดวันนี้" : "เลยกำหนด"} ❌
            </button>
          )}
        </div>
      </div>
      {/* <LineDash /> */}
      <TaskTable key={activeTab} data={getData()} activeTab={activeTab} onReloadTaskTitle={onReloadTaskTitle} curUserId={curUserId} curUserTagId={curUserTagId} containerWidth={containerWidth} filterType={filterType} filterTagId={filterTagId} includeTaskRecurance={includeTaskRecurance} />
    </div>
  );
};

interface SelectTagFilterProps {
  selectedTagId: any;
  tagList: any[];
  onSelectedTagChanged(tagId: any): void;
}
const SelectTagFilter = ({ tagList, selectedTagId, onSelectedTagChanged }: SelectTagFilterProps) => {
  const tagListForSel = tagList.map(x => ({ ...x, label: x.tagName, value: x.tagId }));

  const Option = ({ data, isOption }: { data: any, isOption: boolean }) => {
    return (
      <div className="xyz12 d-flex justify-content-between align-items-center" style={{ gap: 8 }}>
        <span className={isOption ? "ps-2" : ""}>{data.label}</span>
        <span className={isOption ? "pe-2" : ""}>{data.taskCount}</span>
      </div>
    );
  }

  const CustomOption = (props: OptionProps<any>) => {
    const { data } = props;
    return (<components.Option {...props}><Option data={data} isOption={true} /></components.Option>);
  };

  const CustomSingleValue = (props: SingleValueProps<any>) => {
    const { data } = props;
    return (<components.SingleValue {...props}><Option data={data} isOption={false} /></components.SingleValue>);
  };
  const onValueChanged = (tagId: any) => {
    onSelectedTagChanged(tagId);
  }
  return (
    <SelectDropdown
      isDisabled={false}
      list={tagListForSel}
      onValueChanged={onValueChanged}
      selectedValue={tagListForSel.find(e => e.tagId == selectedTagId) ?? null}
      customOption={CustomOption}
      customValue={CustomSingleValue}
      placeholder={"เลือก tag ที่ต้องการดู"}
      isMulti={false}
    />
  );
}

interface TagListControlProps {
  filterTagId: number | null;
  onFilterTagChange(tagId: number | null): void;
  includeTaskRecurance: boolean;
  setIncludeTaskRecurance(val: boolean): void;
}
const TagListControl: React.FC<TagListControlProps> = ({ onFilterTagChange, filterTagId, includeTaskRecurance, setIncludeTaskRecurance }) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.WpSlice,
    (wp: WpSliceData) => ({
      taskDashTags: wp.taskDashTags,
      taskDashTagsLoading: wp.taskDashTagsLoading
    })
  );
  const { taskDashTags, taskDashTagsLoading } = useAppSelector(storeData);

  const onFilterTagChangeIn = (tagID: any) => {
    if (tagID) {
      onFilterTagChange(Utils.ToNumber(tagID, null));
    } else {
      onFilterTagChange(null);
    }
  }

  return (
    <div style={{ position: "relative" }} className="">
      {/* <select className="form-control w-auto mb-2" style={{ minWidth: "200px" }} value={filterTagId == null ? "" : filterTagId.toString()} onChange={(e) => onFilterTagChangeIn(e.target.value)}>
        <option>เลือก tag ที่ต้องการดู</option>
        {taskDashTags.map((item: any, idx: number) => (
          <option key={idx} value={item.tagId}>{item.tagName} ({item.taskCount})</option>
        ))}
      </select> */}
      <div style={{ width: "30%", minWidth: "450px", marginBottom: "8px" }} >
        <div className="d-flex justtify-content-start align-items-center">
          <div className="flex-grow-1">
            <SelectTagFilter onSelectedTagChanged={onFilterTagChangeIn} selectedTagId={filterTagId} tagList={taskDashTags} />
          </div>
          <div className="ms-1">
            <input type="checkbox" id="chkIncludeTaskRecurance" checked={includeTaskRecurance} onChange={(e) => setIncludeTaskRecurance(e.target.checked)} ></input>
            &nbsp;<label htmlFor="chkIncludeTaskRecurance">รวมงานประจำ</label>
          </div>
          {taskDashTagsLoading && (
            <div style={{ position: "absolute", left: "5", top: "8px" }}>
              <LoadingIconWithText loadingText={""} />
            </div>
          )}
        </div>
      </div>
    </div>
    // <div>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>            

    // </div>
  );
}

interface TaskDashRecuranceComponentProps {
  containerWidth: number;
}

const TaskDashRecuranceComponent: React.FC<TaskDashRecuranceComponentProps> = ({ containerWidth }) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Profile2,
    (state: any) => state.WpSlice,
    (p2: UserStruct, wp: WpSliceData) => ({
      taskDashRecurance: wp.taskDashRecurance,
      taskDashRecuranceLoading: wp.taskDashRecuranceLoading,
    })
  );
  const { taskDashRecurance, taskDashRecuranceLoading } = useAppSelector(storeData);
  const [selDivisionName, setSelDivisionName] = useState(null);

  const haveHold = taskDashRecurance.some(t => t.lastTaskStatus == TaskStatus.Hold);
  const haveCancel = taskDashRecurance.some(t => t.lastTaskStatus == TaskStatus.Cancel);

  const divisions = Object.entries(
    taskDashRecurance.reduce((acc, { divisionName }) => {
      acc[divisionName] = (acc[divisionName] || 0) + 1;
      return acc;
    }, {} as Record<string, number>)
  )
    .map(([divisionName, count]) => ({
      value: divisionName,
      count
    }))
    .sort((a, b) => a.value.localeCompare(b.value));

  const recuranceModdeSort = [RecuranceModes.None, RecuranceModes.OneTime, RecuranceModes.Daily, RecuranceModes.Weekly, RecuranceModes.Monthly, RecuranceModes.Yearly];
  const groupTask = (groupBy: "FREQMODE" | "DIVISION" | "EMPLOYEE") => {
    // const selected =
    //   groupBy === "FREQMODE" ? [...taskDashRecurance] :
    //     groupBy === "DIVISION" ? taskDashRecurance.filter(x => x.lastActiveTask != null) :
    //       groupBy === "EMPLOYEE" ? taskDashRecurance.filter(x => x.lastActiveTask != null) : [];
    const selected = [...taskDashRecurance];

    const groups = Object.values(selected.reduce((acc, { recuranceMode, respondId, lastTaskStatus, divisionName, upcomingDayCal, lastTaskOverdueDay, respondName, profileImage }) => {
      const key = groupBy === "FREQMODE" ? recuranceMode : groupBy === "DIVISION" ? divisionName : groupBy == "EMPLOYEE" ? respondId : null;
      if (!acc[key]) {
        acc[key] = { groupValue: key, toDo: 0, onGoing: 0, hold: 0, cancel: 0, finished: 0, upcoming: 0, delay: 0, total: 0, divisionName: "", respondId: 0, respondName: "", profileImage: "" };
      }
      const filter = (groupBy === "FREQMODE" && (selDivisionName == null || selDivisionName == divisionName)) || groupBy !== "FREQMODE";
      if (filter == true) {
        if (lastTaskStatus == TaskStatus.ToDo) acc[key].toDo++;
        else if (lastTaskStatus == TaskStatus.OnGoing) acc[key].onGoing++;
        else if (lastTaskStatus == TaskStatus.Hold) acc[key].hold++;
        else if (lastTaskStatus == TaskStatus.Cancel) acc[key].cancel++;
        else if (lastTaskStatus == TaskStatus.Finished) acc[key].finished++;

        if (upcomingDayCal != null && upcomingDayCal < UPCOMING_DAY) acc[key].upcoming++;
        if (lastTaskOverdueDay !== null && lastTaskOverdueDay !== undefined && lastTaskOverdueDay > 0) acc[key].delay++;
        acc[key].divisionName = divisionName;
        acc[key].respondName = respondName;
        acc[key].respondId = respondId;
        acc[key].profileImage = profileImage;
        acc[key].total++;
      }

      return acc;
    }, {} as Record<string, { groupValue: any, toDo: number, onGoing: number, hold: number, cancel: number, finished: number, upcoming: number, delay: number, divisionName: string, respondName: string, respondId: number }>));
    return groupBy == "FREQMODE" ? groups.sort((a: any, b: any) => recuranceModdeSort.indexOf(a.groupValue) - recuranceModdeSort.indexOf(b.groupValue)) : groups;
  }

  const byTaskStatus = groupTask("FREQMODE");
  const byDivisions = groupTask("DIVISION");
  const byEmp = groupTask("EMPLOYEE");

  const Option = ({ data, isOption }: { data: any, isOption: boolean }) => {
    return (
      <div className="xyz12 d-flex justify-content-between align-items-center" style={{ gap: 8 }}>
        <span className={isOption ? "ps-2" : ""}>{data.value}</span>
        <span className={isOption ? "pe-2" : ""}>{data.count}</span>
      </div>
    );
  }

  const CustomOption = (props: OptionProps<any>) => {
    const { data } = props;
    return (<components.Option {...props}><Option data={data} isOption={true} /></components.Option>);
  };

  const CustomSingleValue = (props: SingleValueProps<any>) => {
    const { data } = props;
    return (<components.SingleValue {...props}><Option data={data} isOption={false} /></components.SingleValue>);
  };

  const taskDisabled = taskDashRecurance.filter(x => selDivisionName == null || selDivisionName == x.divisionName).filter(x => x.enabled == false).length;
  const taskPersonInActive = taskDashRecurance.filter(x => selDivisionName == null || selDivisionName == x.divisionName).filter(x => x.isSomePersonInActive == true).length;
  const taskNoNextCreation = taskDashRecurance.filter(x => selDivisionName == null || selDivisionName == x.divisionName).filter(x => x.enabled == true && x.nextDateCreateTask1 == null).length;
  const taskNeverCreate = taskDashRecurance.filter(x => selDivisionName == null || selDivisionName == x.divisionName).filter(x => x.lastActiveTask == null).length;

  const isBigScreen = containerWidth > SMALL_SCREEN;
  const [divExpand, setDivExpand] = useState<string | null>(StorageUtils.TaskDashRecuranceDivExpand);
  const toggleDiv = (divisionName: string) => {
    setDivExpand(prev => prev == divisionName ? null : divisionName);
  }
  useEffect(() => {
    StorageUtils.TaskDashRecuranceDivExpand = divExpand;
  }, [divExpand]);
  const FIRST_COL_WIDTH = "250px";


  interface TaskListOptions {
    taskDisabled?: boolean;
    taskPersonInActive?: boolean;
    taskNoNextCreation?: boolean;
    taskNeverCreate?: boolean;
    recuranceMode?: any;
    respondId?: number;
    division?: string | null;
    status?: "OVERDUE" | "UPCOMING" | "ALL" | string;
    taskList?: any;
  }

  const [showPopTaskList, setShowPopTaskList] = useState<boolean>(false);
  const [popTaskList, setPopTaskList] = useState<TaskListOptions>({ taskList: [] });
  const { ref: popRef, pos: popCur, openAtCursor } = useCursorPopup(
    showPopTaskList,
    () => setShowPopTaskList(false)
  );

  const minWidthPopTasklist = popCur.width < 720 ? "calc(100vw - 4px)" : "500px";

  const openTaskList = (e: React.MouseEvent<HTMLElement>, opt: TaskListOptions) => {
    try {
      const filter = taskDashRecurance.filter(x => {
        let statusMatch =
          opt.status == null ? true :
            opt.status == "OVERDUE" ? (x.lastTaskOverdueDay !== null && x.lastTaskOverdueDay !== undefined && x.lastTaskOverdueDay > 0) :
              opt.status == "UPCOMING" ? (x.upcomingDayCal != null && x.upcomingDayCal < UPCOMING_DAY) :
                opt.status == "ALL" ? true : x.lastTaskStatus == opt.status;

        return (opt.taskDisabled == null || x.enabled == false)
          && (opt.taskPersonInActive == null || x.isSomePersonInActive == true)
          && (opt.taskNoNextCreation == null || x.enabled == true && x.nextDateCreateTask1 == null)
          && (opt.taskNeverCreate == null || x.lastActiveTask == null)
          && (opt.recuranceMode == null || x.recuranceMode == opt.recuranceMode)
          && (opt.respondId == null || x.respondId == opt.respondId)
          && (opt.division == null || x.divisionName == opt.division)
          && statusMatch;
      });

      const filter2 = opt.status === "UPCOMING"
        ? filter.sort((a, b) => (Utils.ConvertApiDate(a.nextDateCreateTask1)?.getTime() ?? Infinity) - (Utils.ConvertApiDate(b.nextDateCreateTask1)?.getTime() ?? Infinity))
        : filter.sort((a, b) => { return a.ordering - b.ordering });

      setPopTaskList({ ...opt, taskList: filter2 });

      openAtCursor(e);
      setShowPopTaskList(filter2.length > 0);
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }


  useEffect(() => {
    if (!popRef.current) return;

    const rect = popRef.current.getBoundingClientRect();

    let top = popCur.y + 20;
    let left = popCur.x;

    if (top + rect.height > window.innerHeight)
      top = popCur.y - rect.height - 10;

    if (left + rect.width > window.innerWidth)
      left = window.innerWidth - rect.width - 20;

    popRef.current.style.top = `${top}px`;
    popRef.current.style.left = `${left}px`;
  }, [popCur]);

  const dialog = useDialog();
  const onClickTask = async (task: any) => {
    try {
      if (task.lastActiveTask) {
        await Utils.Tk_OpenTask(task.lastActiveTask, false, dispatch);
      } else {// if (task.taskRecuranceId) {
        Utils.SweetAlert('ยังไม่มีงาน');
        // await dialog.showTaskRecurance({ postId: task.taskRecuranceId });
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  return (
    <>
      {showPopTaskList && (
        <div ref={popRef} className="context-container d-flex" style={{ flexDirection: "column", zIndex: "19", minWidth: minWidthPopTasklist, minHeight: "200px", maxHeight: "470px", maxWidth: "calc(100vw - 60px)", position: "fixed"/*, top: top, left: left*/ }}>
          <AppSimpleBar className="" style={{ maxHeight: "400px" }}>
            {(popTaskList.taskList ?? []).map((tk: any, index: any) => {
              const taskStatus = tk.lastTaskStatus;
              const taskOverdueDay = Utils.ToNumber(tk.lastTaskOverdueDay, null) ?? 0;
              const dueIcon = tk.lastActiveTask == null ? "" : taskOverdueDay > 0 ? "🚨" : "";
              const dueText = tk.lastActiveTask == null ? "ยังไม่สร้าง" : (dueIcon + 'Due:' + Utils.GetDMY(tk.lastTaskPlanFinishedDate));
              const showUpcoming = popTaskList.status === "UPCOMING";
              const taskName = showUpcoming ? tk.nextTaskName : tk.taskName;
              const dueCss = showUpcoming ? "text-warning" : tk.lastActiveTask == null ? "text-secondary" : taskOverdueDay > 0 ? "text-danger" : "text-info";

              return (
                <div key={index} className="hover hand p-2" style={{ borderBottom: "dashed 1px gray" }} onClick={() => onClickTask(tk)} >
                  <div className="d-flex justify-content-between align-items-center mb-0">
                    <div className="d-flex align-items-center ">
                      <UserAvatarWithName keyValue={index} abbrName="" backColor="" displayName2="" foreColor="" profileImage={tk.lastTaskProfileImage ?? tk.profileImage} userId={tk.respondId} />
                      <span className="">{taskName}</span>
                    </div>
                    {showUpcoming ? (<div className={"small no-wrap " + dueCss}>Start: {Utils.GetDMY(tk.nextDateCreateTask1)}</div>) : (<div className={"small no-wrap " + dueCss}>{dueText}</div>)}


                  </div>

                  {!showUpcoming && (
                    <div className="d-flex justify-content-between align-items-center mt-0">
                      <div className="text-muted small ms-4">{Utils.GetTaskStatusIcon(tk.lastTaskStatus)}{Utils.GetTaskStatusText(tk.lastTaskStatus)}</div>
                      <div className="text-muted small">Next: {tk.nextDateCreateTask1 ? Utils.GetDMY(tk.nextDateCreateTask1) : "None"}</div>
                    </div>
                  )}

                </div>
              );
            })}
          </AppSimpleBar>
          <div style={{ marginTop: "auto", marginBottom: "4px" }}>
            <button className="btn2 btn2-warning w-100 " onClick={(e) => setShowPopTaskList(false)}>ปิด</button>
          </div>
          {/* {subTaskLoading && (<Loader />)}

          <div style={{ marginTop: "auto", marginBottom: "4px" }}>
            <button className="btn btn-sm fz-10 btn-outline-primary w-100" style={{ border: "solid 1px gray" }} title="สร้างงานขึ้นมาใหม่ ตามรูปแบบที่ตั้งค่าไว้" onClick={() => createSubTaskCreating ? null : fnCreateChildTask()}>
              {createSubTaskCreating && (<LoadingIconWithText loadingText={"กำลังสร้าง...."} />)}
              {!createSubTaskCreating && (<>สร้างงานถัดไป จากรูปแบบนี้</>)}
            </button>
          </div> */}
        </div>
      )}
      <div className="flex-grow-1" style={{ minHeight: "0" }} >
        <div className="d-flex flex-column h-100">
          <div>
            <div className="tkd-status-summary-card wp-conver-content" style={{ height: "100%", width: "100%", maxWidth: "100%" }}>
              <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                <div style={{ minWidth: "350px" }}>
                  <SelectDropdown
                    isDisabled={false}
                    list={divisions}
                    onValueChanged={(e) => setSelDivisionName(e)}
                    selectedValue={divisions.find(e => e.value == selDivisionName) ?? null}
                    customOption={CustomOption}
                    customValue={CustomSingleValue}
                    placeholder={"หน่วยงาน"}
                    isMulti={false}
                  />
                </div>
                <div className={"d-flex flex-wrap"} style={{ gap: "8px" }}>
                  {taskDisabled > 0 && (<button className="btn2 btn2-warning fz-09 hover-u" onClick={(e) => openTaskList(e, { taskDisabled: true, division: selDivisionName })}><i className="fa fa-warning text-danger"></i> มี <span className="text-danger">{taskDisabled}</span> งาน disabled</button>)}
                  {taskPersonInActive > 0 && (<button className="btn2 btn2-warning fz-09 hover-u" onClick={(e) => openTaskList(e, { taskPersonInActive: true, division: selDivisionName })}><i className="fa fa-warning text-danger"></i> มี <span className="text-danger">{taskPersonInActive}</span> งาน ที่ผู้เกี่ยวข้องลาออก</button>)}
                  {taskNoNextCreation > 0 && (<button className="btn2 btn2-warning fz-09 hover-u" onClick={(e) => openTaskList(e, { taskNoNextCreation: true, division: selDivisionName })}><i className="fa fa-warning text-danger"></i> มี <span className="text-danger">{taskNoNextCreation}</span> งาน ที่จะไม่มีงานรอบถัดไป</button>)}
                  {taskNeverCreate > 0 && (<button className="btn2 btn2-warning fz-09 hover-u" onClick={(e) => openTaskList(e, { taskNeverCreate: true, division: selDivisionName })}><i className="fa fa-warning text-danger"></i> มี <span className="text-danger">{taskNeverCreate}</span> งาน ที่ยังไม่เคยสร้าง</button>)}
                </div>
              </div>
              <LineDash />
              <table className="tkd-task-table" style={{ width: "100% !important" }}>
                <thead>
                  <tr style={{ borderBottom: "dashed 1px gray" }}>
                    <th >ความถี่</th>
                    <th className="hover-u hand" onClick={(e) => openTaskList(e, { status: TaskStatus.ToDo.toString(), division: selDivisionName })}><span className={"badge-task-status-todo"}>{Utils.GetTaskStatusIcon(TaskStatus.ToDo)}{isBigScreen && Utils.GetTaskStatusText(TaskStatus.ToDo)}</span></th>
                    <th className="hover-u hand" onClick={(e) => openTaskList(e, { status: TaskStatus.OnGoing.toString(), division: selDivisionName })}><span className={"badge-task-status-ongoing"}>{Utils.GetTaskStatusIcon(TaskStatus.OnGoing)}{isBigScreen && Utils.GetTaskStatusText(TaskStatus.OnGoing)}</span></th>
                    {haveHold && (<th className="hover-u hand" onClick={(e) => openTaskList(e, { status: TaskStatus.Hold.toString(), division: selDivisionName })}><span className={"badge-task-status-hold"}>{Utils.GetTaskStatusIcon(TaskStatus.Hold)}{isBigScreen && Utils.GetTaskStatusText(TaskStatus.Hold)}</span></th>)}
                    {haveCancel && (<th className="hover-u hand" onClick={(e) => openTaskList(e, { status: TaskStatus.Cancel.toString(), division: selDivisionName })}><span className={"badge-task-status-cancel"}>{Utils.GetTaskStatusIcon(TaskStatus.Cancel)}{isBigScreen && Utils.GetTaskStatusText(TaskStatus.Cancel)}</span></th>)}
                    <th className="hover-u hand" onClick={(e) => openTaskList(e, { status: TaskStatus.Finished.toString(), division: selDivisionName })}><span className={"badge-task-status-finished"}>{Utils.GetTaskStatusIcon(TaskStatus.Finished)}{isBigScreen && Utils.GetTaskStatusText(TaskStatus.Finished)}</span></th>
                    <th className="hover-u hand" onClick={(e) => openTaskList(e, { status: "OVERDUE", division: selDivisionName })}><span className="text-danger">🚨{isBigScreen && (<>Overdue</>)}</span></th>
                    <th className="hover-u hand" onClick={(e) => openTaskList(e, { status: "UPCOMING", division: selDivisionName })}><span className="text-warning">⚡️{isBigScreen && (<>Upcoming</>)}</span></th>
                    <th className="hover-u hand" onClick={(e) => openTaskList(e, { status: "ALL", division: selDivisionName })}><span className="text-info">*️⃣{isBigScreen && (<>Total</>)}</span></th>
                  </tr>
                </thead>
                <tbody>
                  {byTaskStatus.map((x: any, idx: number) => {
                    const mode = x.groupValue as RecuranceModes;
                    const freq
                      = mode == RecuranceModes.None ? "None"
                        : mode == RecuranceModes.OneTime ? "ครั้งเดียว"
                          : mode == RecuranceModes.Daily ? "รายวัน"
                            : mode == RecuranceModes.Weekly ? "รายอาทิตย์"
                              : mode == RecuranceModes.Monthly ? "รายเดือน"
                                : mode == RecuranceModes.Yearly ? "รายปี"
                                  : "N/A";

                    return (
                      <tr key={idx} className="hover">
                        <td align="center" style={{ width: FIRST_COL_WIDTH }} className="hover-u hand" onClick={(e) => openTaskList(e, { recuranceMode: mode, division: selDivisionName })}>{freq} </td>
                        <td align="center" className="badge-task-status-todo hover-u hand" onClick={(e) => openTaskList(e, { recuranceMode: mode, status: TaskStatus.ToDo.toString(), division: selDivisionName })}>{x.toDo > 0 ? x.toDo : null}</td>
                        <td align="center" className="badge-task-status-ongoing hover-u hand" onClick={(e) => openTaskList(e, { recuranceMode: mode, status: TaskStatus.OnGoing.toString(), division: selDivisionName })}>{x.onGoing > 0 ? x.onGoing : null}</td>
                        {haveHold && (<td align="center" className="badge-task-status-hold hover-u hand" onClick={(e) => openTaskList(e, { recuranceMode: mode, status: TaskStatus.Hold.toString(), division: selDivisionName })}>{x.hold > 0 ? x.hold : null}</td>)}
                        {haveCancel && (<td align="center" className="badge-task-status-cancel hover-u hand" onClick={(e) => openTaskList(e, { recuranceMode: mode, status: TaskStatus.Cancel.toString(), division: selDivisionName })}>{x.cancel > 0 ? x.cancel : null}</td>)}
                        <td align="center" className="badge-task-status-finished hover-u hand" onClick={(e) => openTaskList(e, { recuranceMode: mode, status: TaskStatus.Finished.toString(), division: selDivisionName })}>{x.finished > 0 ? x.finished : null}</td>
                        <td align="center" className="text-danger hover-u hand" onClick={(e) => openTaskList(e, { recuranceMode: mode, status: "OVERDUE", division: selDivisionName })}>{x.delay > 0 ? x.delay : null}</td>
                        <td align="center" className="text-warning hover-u hand" onClick={(e) => openTaskList(e, { recuranceMode: mode, status: "UPCOMING", division: selDivisionName })}>{x.upcoming > 0 ? x.upcoming : null}</td>
                        <td align="center" className="text-info hover-u hand" onClick={(e) => openTaskList(e, { recuranceMode: mode, division: selDivisionName })}>{x.total > 0 ? x.total : null}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>

            </div >
          </div>
          <div className="flex-grow-1" style={{ minHeight: "0" }} >
            <AppSimpleBar className="tkd-status-summary-card wp-conver-content mt-2" style={{ width: "100%", maxWidth: "100%", height: "100%" }} autoHide={false}>
              <table className="tkd-task-table w-100">
                <thead>
                  <tr style={{ borderBottom: "dashed 1px gray" }}>
                    <th align="left">เจ้าของงาน</th>
                    <th className="hand hover-u" onClick={(e) => openTaskList(e, { status: TaskStatus.ToDo.toString(), division: selDivisionName })}><span className={"badge-task-status-todo"}>{Utils.GetTaskStatusIcon(TaskStatus.ToDo)}{isBigScreen && Utils.GetTaskStatusText(TaskStatus.ToDo)}</span></th>
                    <th className="hand hover-u" onClick={(e) => openTaskList(e, { status: TaskStatus.OnGoing.toString(), division: selDivisionName })}><span className={"badge-task-status-ongoing"}>{Utils.GetTaskStatusIcon(TaskStatus.OnGoing)}{isBigScreen && Utils.GetTaskStatusText(TaskStatus.OnGoing)}</span></th>
                    {haveHold && (<th className="hand hover-u" onClick={(e) => openTaskList(e, { status: TaskStatus.Hold.toString(), division: selDivisionName })}><span className={"badge-task-status-hold"}>{Utils.GetTaskStatusIcon(TaskStatus.Hold)}{isBigScreen && Utils.GetTaskStatusText(TaskStatus.Hold)}</span></th>)}
                    {haveCancel && (<th className="hand hover-u" onClick={(e) => openTaskList(e, { status: TaskStatus.Cancel.toString(), division: selDivisionName })}><span className={"badge-task-status-cancel"}>{Utils.GetTaskStatusIcon(TaskStatus.Cancel)}{isBigScreen && Utils.GetTaskStatusText(TaskStatus.Cancel)}</span></th>)}
                    <th className="hand hover-u" onClick={(e) => openTaskList(e, { status: TaskStatus.Finished.toString(), division: selDivisionName })}><span className={"badge-task-status-finished"}>{Utils.GetTaskStatusIcon(TaskStatus.Finished)}{isBigScreen && Utils.GetTaskStatusText(TaskStatus.Finished)}</span></th>
                    <th className="hand hover-u" onClick={(e) => openTaskList(e, { status: "OVERDUE", division: selDivisionName })}><span className="text-danger">🚨{isBigScreen && (<>Overdue</>)}</span></th>
                    <th className="hand hover-u" onClick={(e) => openTaskList(e, { status: "UPCOMING", division: selDivisionName })}><span className="text-warning" title="งานใกล้เริ่มในอีก 7 วัน">⚡️{isBigScreen && (<>Upcoming</>)}</span></th>
                    <th className="hand hover-u" onClick={(e) => openTaskList(e, { status: "ALL", division: selDivisionName })}><span className="text-info">*️⃣{isBigScreen && (<>Total</>)}</span></th>
                  </tr>
                </thead>
                <tbody>
                  {byDivisions.map((div: any, idxDiv: number) => {
                    // const emp = taskDashRecurance.filter(x => x.divisionName == div.groupValue);
                    const emp = byEmp.filter((x: any) => x.divisionName == div.groupValue);
                    const expanded = divExpand == div.groupValue;// groupByDivision ? memDivCollapse.includes(div.divisionName) : true;
                    const divKey = div.groupValue; //groupByDivision ? div.divisionName : "";
                    return (
                      <Fragment key={idxDiv}>
                        {div.groupValue && (
                          <tr key={divKey + idxDiv} className="text-primary hover" >
                            <td className="hand hover" style={{ width: FIRST_COL_WIDTH }} onClick={(e) => toggleDiv(div.groupValue)}><i className={"fas fa-angle-double-" + (expanded ? "up" : "down") + " me-1"}></i>{div.groupValue}</td>
                            <td align="center" className="badge-task-status-todo hand hover-u" onClick={(e) => openTaskList(e, { status: TaskStatus.ToDo.toString(), division: divKey })}>{div.toDo > 0 ? div.toDo : null}</td>
                            <td align="center" className="badge-task-status-ongoing hand hover-u" onClick={(e) => openTaskList(e, { status: TaskStatus.OnGoing.toString(), division: divKey })}>{div.onGoing > 0 ? div.onGoing : null}</td>
                            {haveHold && (<td align="center" className="badge-task-status-hold hand hover-u" onClick={(e) => openTaskList(e, { status: TaskStatus.Hold.toString(), division: divKey })}>{div.hold > 0 ? div.hold : null}</td>)}
                            {haveCancel && (<td align="center" className="badge-task-status-cancel hand hover-u" onClick={(e) => openTaskList(e, { status: TaskStatus.Cancel.toString(), division: divKey })}>{div.cancel > 0 ? div.cancel : null}</td>)}
                            <td align="center" className="badge-task-status-finished hand hover-u" onClick={(e) => openTaskList(e, { status: TaskStatus.Finished.toString(), division: divKey })}>{div.finished > 0 ? div.finished : null}</td>
                            <td align="center" className="text-danger hand hover-u" onClick={(e) => openTaskList(e, { status: "OVERDUE", division: divKey })}>{div.delay > 0 ? div.delay : null}</td>
                            <td align="center" className="text-warning hand hover-u" onClick={(e) => openTaskList(e, { status: "UPCOMING", division: divKey })} title="งานใกล้เริ่มในอีก 7 วัน">{div.upcoming > 0 ? div.upcoming : null}</td>
                            <td align="center" className="text-info hand hover-u" onClick={(e) => openTaskList(e, { division: divKey })} >{div.total > 0 ? div.total : null}</td>
                          </tr>
                        )}
                        {expanded && emp.map((row: any, idx: number) => {
                          return (
                            <tr key={divKey + idx} className="hover">
                              <td className={"hand hover ps-4 no-wrap overflow-hide hand hover-u"} onClick={(e) => openTaskList(e, { respondId: row.respondId })} style={{ maxWidth: FIRST_COL_WIDTH }} >{row.displayName}
                                <UserAvatarWithName keyValue={idx} abbrName={""} backColor={""} displayName2={row.respondName} foreColor={""} profileImage={row.profileImage} userId={row.respondId} />
                              </td>
                              <td align="center" className="badge-task-status-todo hand hover-u" onClick={(e) => openTaskList(e, { status: TaskStatus.ToDo.toString(), respondId: row.respondId })}>{row.toDo > 0 ? row.toDo : null}</td>
                              <td align="center" className="badge-task-status-ongoing hand hover-u" onClick={(e) => openTaskList(e, { status: TaskStatus.OnGoing.toString(), respondId: row.respondId })}>{row.onGoing > 0 ? row.onGoing : null}</td>
                              {haveHold && (<td align="center" className="badge-task-status-hold hand hover-u" onClick={(e) => openTaskList(e, { status: TaskStatus.Hold.toString(), respondId: row.respondId })}>{row.hold > 0 ? row.hold : null}</td>)}
                              {haveCancel && (<td align="center" className="badge-task-status-cancel hand hover-u" onClick={(e) => openTaskList(e, { status: TaskStatus.Cancel.toString(), respondId: row.respondId })}>{row.cancel > 0 ? row.cancel : null}</td>)}
                              <td align="center" className="badge-task-status-finished hand hover-u" onClick={(e) => openTaskList(e, { status: TaskStatus.Finished.toString(), respondId: row.respondId })}>{row.finished > 0 ? row.finished : null}</td>
                              <td align="center" className="text-danger hand hover-u" onClick={(e) => openTaskList(e, { status: "OVERDUE", respondId: row.respondId })}>{row.delay > 0 ? row.delay : null}</td>
                              <td align="center" className="text-warning hand hover-u" onClick={(e) => openTaskList(e, { status: "UPCOMING", respondId: row.respondId })}>{row.upcoming > 0 ? row.upcoming : null}</td>
                              <td align="center" className="text-info hand hover-u" onClick={(e) => openTaskList(e, { respondId: row.respondId })}>{row.total > 0 ? row.total : null}</td>
                            </tr>
                          )
                        })}
                      </Fragment>
                    )
                  })}
                </tbody>
              </table>
            </AppSimpleBar>
          </div>
        </div>
      </div >
    </>
  );
};

const WelcomeTask2 = () => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Profile2,
    (state: any) => state.WpSlice,
    (p2: UserStruct, wp: WpSliceData) => ({
      curUser: p2,
      taskAll: wp.taskDash?.taskAll,
      taskResponder: wp.taskDash?.taskResponder,
      taskAssigner: wp.taskDash?.taskAssigner,
      taskRequester: wp.taskDash?.taskRequester,
      taskStatusRange: wp.taskDash?.taskStatusRange,
      taskDashStatusLoading: wp.taskDashStatusLoading ?? false,
      taskDashLoadingX: wp.taskDashLoading ?? false,
      taskStatusesEx: wp.titlesTk.map(x => `${x.taskStatus}`).join("|"),
      taskDashFilterTagId: wp.taskDashFilterTagId,
      // taskStatusesx: wp.titlesTk.map(x => `${x.taskStatus}`).join("|"),
      taskDashRecurance: wp.taskDashRecurance,
      taskDashRecuranceLoading: wp.taskDashRecuranceLoading,
      taskDashLoading: (wp.taskDashLoading ?? false) || (wp.taskDashRecuranceLoading),
    })
  );
  const { curUser, taskAll, taskResponder, taskAssigner, taskRequester, taskStatusesEx, taskStatusRange, taskDashStatusLoading, taskDashLoading, taskDashFilterTagId, taskDashRecurance } = useAppSelector(storeData);

  const [date1, setDate1] = useState<Date | null>(Utils.GetFirstDateOfWeek(null));
  const [date2, setDate2] = useState<Date | null>(Utils.GetLastDateOfWeek(null));
  const [dashboardTaskSelTab, setDashboardTaskSelTab] = useState<DashTaskTabs>(StorageUtils.DashboardTaskSelTab);
  // const [filterTagId, setFilterTagId] = useState<number | null>(StorageUtils.DashboardFilterTagId);


  const onDateChange = (dateParm1: Date, dateParm2: Date) => {
    setDate1(dateParm1);
    setDate2(dateParm2);
    dispatch(loadTaskDashStatusRangeActV2(dateParm1, dateParm2, taskDashFilterTagId, includeTaskRecurance));
  }


  useEffect(() => {
    dispatch(loadTaskDashActV2(StorageUtils.TaskDashDivMode, date1, date2, taskDashFilterTagId, includeTaskRecurance));
  }, [taskStatusesEx]);

  useEffect(() => {
    dispatch(loadTaskDashActV2(StorageUtils.TaskDashDivMode, date1, date2, taskDashFilterTagId, includeTaskRecurance));
    dispatch(loadTaskDashTagsActV2(includeTaskRecurance));
  }, []);

  const taskStatusAll = {
    status_ToDo: taskAll?.reduce((acc: any, cur: any) => { return acc + cur.status_ToDo }, 0),
    status_Finished: taskAll?.reduce((acc: any, cur: any) => { return acc + cur.status_Finished }, 0),
    status_Cancel: taskAll?.reduce((acc: any, cur: any) => { return acc + cur.status_Cancel }, 0),
    status_OnGoing: taskAll?.reduce((acc: any, cur: any) => { return acc + cur.status_OnGoing }, 0),
    status_Hold: taskAll?.reduce((acc: any, cur: any) => { return acc + cur.status_Hold }, 0),
  }

  const onReloadTaskTitle = async (fromDivGroup: boolean, taskStatus: TaskStatus | null, respondId: string | null | undefined, respondTagId: number[] | null, assignerId: any, requesterId: any, keyword: string) => {
    console.log('onReloadTaskTitle:', { fromDivGroup, taskStatus, respondId, respondTagId, assignerId, requesterId, keyword });
    const memberRole = Utils.GetMemberRoleFromStorage(WpModes.Task);
    const sortMode = Utils.Conf_WorkPlaceSortMode(WpModes.Task);
    const filterStaus = taskStatus ? [taskStatus] : [];
    const tags = respondTagId != null ? respondTagId : taskAll?.map((x: any) => x.respondTagId);
    const tag2 = taskDashFilterTagId == null ? [] : [taskDashFilterTagId];
    if (fromDivGroup) {
      const divMode = StorageUtils.TaskDashDivMode;
      let divKeyword = divMode;
      if (["DIV_RSP", "DIV_ASG", "DIV_REQ"].includes(divMode)) {
        if (filterType === "COMING_DUE") divKeyword += "|COMING";
        else if (filterType === "DUE_TODAY") divKeyword += "|TODAY";
        else if (filterType === "OVERDUE") divKeyword += "|OVERDUE";
      }
      dispatch(loadPostTitleActionV2(
        WpModes.Task, divKeyword, [], memberRole, tag2/*tags*/, false, false, WpEmpFilterType.TaskOwner, null, Const.LOAD_POST_TITLE_CALLING_FROM_DASH,
        filterStaus, true, respondTagId?.join('|'), assignerId, requesterId, null, null, includeTaskRecurance, null, sortMode
      ));
    } else {
      dispatch(loadPostTitleActionV2(
        WpModes.Task, keyword, [], memberRole, tag2/*tags*/, false, false, WpEmpFilterType.TaskOwner, null, Const.LOAD_POST_TITLE_CALLING_FROM_DASH,
        filterStaus, true, respondId, assignerId, requesterId, null, null, includeTaskRecurance, null, sortMode
      ));
    }
  }

  const [filterType, setFilterType] = useState<CurrentFilterType>(StorageUtils.TaskDashFilterType);
  useEffect(() => {
    StorageUtils.TaskDashFilterType = filterType;
  }, [filterType]);


  const onFilterTaskTitle = async (mode: "NEW_TASK" | "FINISHED_TASK" | "COMING_DUE" | "DUE_TODAY" | "OVERDUE") => {
    const taskStatus = mode == "NEW_TASK" ? TaskStatus.ToDo : TaskStatus.Finished;
    const memberRole = Utils.GetMemberRoleFromStorage(WpModes.Task);
    const sortMode = Utils.Conf_WorkPlaceSortMode(WpModes.Task);
    const filterStaus = taskStatus ? [taskStatus] : [];

    const tags = taskAll?.map((x: any) => x.respondTagId);
    const tags2 = taskDashFilterTagId == null ? [] : [taskDashFilterTagId];
    // console.log('onFilterTaskTitle:', {mode, memberRole});
    dispatch(loadPostTitleActionV2(
      WpModes.Task, mode, [], memberRole, tags2 /*tags*/, false, false, WpEmpFilterType.TaskOwner, null, Const.LOAD_POST_TITLE_CALLING_FROM_DASH, filterStaus, true, null, null, null, date1, date2, includeTaskRecurance, null, sortMode
    ));

    setFilterType((mode == "COMING_DUE" || mode == "DUE_TODAY" || mode == "OVERDUE") ? mode : null);
  }

  // type DATE_RANGES = "THIS_WEEK" | "PREV_WEEK" | "THIS_MONTH" | "PREV_MONTH";
  // const [selDateRange, setSelDateRange] = useState<DATE_RANGES>("THIS_WEEK");
  const { ref, width: containerWidth } = ElementWidthObserver<HTMLDivElement>();
  const onRefresh = async () => {
    setFilterType(null);
    dispatch(loadTaskDashActV2(StorageUtils.TaskDashDivMode, date1, date2, null, includeTaskRecurance));
    dispatch(loadTaskDashRecurance());
    dispatch(loadTaskDashTagsActV2(includeTaskRecurance));
  }

  const onFilterTagIdChange = (tagID: number | null) => {

    dispatch(setTaskDashFilterTagId(tagID));
    StorageUtils.DashboardFilterTagId = tagID;
    dispatch(loadTaskDashActV2(StorageUtils.TaskDashDivMode, date1, date2, tagID, includeTaskRecurance));
  }

  const onDashboardTaskSelTabChanged = (selTab: DashTaskTabs) => {
    setDashboardTaskSelTab(prev => {
      StorageUtils.DashboardTaskSelTab = selTab;
      return selTab;
    });
  }

  const [includeTaskRecurance, setIncludeTaskRecurance] = useState<boolean>(StorageUtils.TaskDashIncludeTaskRecurance);
  const onSetIncludeTaskRecurance = (val: boolean) => setIncludeTaskRecurance(val);
  useEffect(() => {
    StorageUtils.TaskDashIncludeTaskRecurance = includeTaskRecurance;
    dispatch(loadTaskDashActV2(StorageUtils.TaskDashDivMode, date1, date2, taskDashFilterTagId, includeTaskRecurance));
  }, [includeTaskRecurance])

  return (
    <React.Fragment>
      <div ref={ref} className="chat-welcome-section " style={{ alignItems: "flex-start", justifyContent: "flex-start", width: "100%", height: "calc(100vh)" }} >
        <div className="d-flex flex-column tkd-dashboard-container w-100" style={{ height: "100%" }}>
          <div className="d-flex justify-content-between mb-2">
            <div>
              <button className={"btn2 btn2-" + (dashboardTaskSelTab == DashTaskTabs.ALL_TASK ? "" : "outline-") + "secondary fz-11 p-2"} onClick={(e) => onDashboardTaskSelTabChanged(DashTaskTabs.ALL_TASK)}>
                สรุปงานประจำปี
                <HelpInfo infos={[
                  "Dashboard แสดงงานทั้งหมด ของพนักงานตามสายงาน/พนักงานที่ติดตาม/เป็นผู้มอบหมาย/ผู้ของาน"
                  , "เป็นข้อมูลงานในปีปัจจุบัน"
                ]} />

              </button>
              &nbsp;&nbsp;&nbsp;
              <button className={"btn2 btn2-" + (dashboardTaskSelTab == DashTaskTabs.RECURANCE_TASK ? "" : "outline-") + "secondary fz-11 p-2"} onClick={(e) => onDashboardTaskSelTabChanged(DashTaskTabs.RECURANCE_TASK)}>
                สรุปงานประจำ <span className="text-info">{taskDashRecurance.length}</span> งาน
              </button>
            </div>
            <h4>
              {taskDashLoading && (<LoadingIconWithText loadingText={""} />)}
              {!taskDashLoading && (<i className="fa fa-refresh hand" onClick={onRefresh}></i>)}
            </h4>
          </div>

          {dashboardTaskSelTab === DashTaskTabs.ALL_TASK && (
            <>
              <UserHeader
                user={curUser}
                myTaskSummary={taskResponder}
                allTaskSummary={taskStatusAll}
                onReloadTaskTitle={onReloadTaskTitle}
                curUserId={curUser.userId ?? -1}
                curUserTagId={curUser.userId ?? -1}
                onDateChange={onDateChange}
                taskStatusRange={taskStatusRange}
                taskDashStatusLoading={taskDashStatusLoading}
                onFilterTaskTitle={onFilterTaskTitle}
                onRefresh={onRefresh}
                taskDashLoading={taskDashLoading}
                onFilterTagChange={onFilterTagIdChange}
                filterTagId={taskDashFilterTagId}
                includeTaskRecurance={includeTaskRecurance}
                setIncludeTaskRecurance={setIncludeTaskRecurance}
              />
              <LineDash />
              <TaskTabs
                allTasks={taskAll}
                assignerTasks={taskAssigner}
                requesterTasks={taskRequester}
                onReloadTaskTitle={onReloadTaskTitle}
                curUserId={curUser.userId ?? -1}
                curUserTagId={curUser.userId ?? -1}
                containerWidth={containerWidth}
                filterType={filterType}
                onClearFilterType={() => setFilterType(null)}
                filterTagId={taskDashFilterTagId}
                includeTaskRecurance={includeTaskRecurance}
              />
            </>
          )}

          {dashboardTaskSelTab === DashTaskTabs.RECURANCE_TASK && (
            <TaskDashRecuranceComponent containerWidth={containerWidth} />
          )}


        </div>
      </div>

    </React.Fragment>
  );
};

export default WelcomeTask2;
